export const toNumber = (value: string) =>
  Number(
    value
      .replace('.', '')
      .replace(',', '.')
      .replace(/[^\d.]+/g, ''),
  );
